"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _MonotoneChain = _interopRequireDefault(require("./MonotoneChain"));

var _Integer = _interopRequireDefault(require("../../../../../java/lang/Integer"));

var _ArrayList = _interopRequireDefault(require("../../../../../java/util/ArrayList"));

var _Quadrant = _interopRequireDefault(require("../../geomgraph/Quadrant"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var MonotoneChainBuilder =
/*#__PURE__*/
function () {
  function MonotoneChainBuilder() {
    _classCallCheck(this, MonotoneChainBuilder);

    MonotoneChainBuilder.constructor_.apply(this, arguments);
  }

  _createClass(MonotoneChainBuilder, [{
    key: "getClass",
    value: function getClass() {
      return MonotoneChainBuilder;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }], [{
    key: "getChainStartIndices",
    value: function getChainStartIndices(pts) {
      var start = 0;
      var startIndexList = new _ArrayList.default();
      startIndexList.add(new _Integer.default(start));

      do {
        var last = MonotoneChainBuilder.findChainEnd(pts, start);
        startIndexList.add(new _Integer.default(last));
        start = last;
      } while (start < pts.length - 1);

      var startIndex = MonotoneChainBuilder.toIntArray(startIndexList);
      return startIndex;
    }
  }, {
    key: "findChainEnd",
    value: function findChainEnd(pts, start) {
      var safeStart = start;

      while (safeStart < pts.length - 1 && pts[safeStart].equals2D(pts[safeStart + 1])) {
        safeStart++;
      }

      if (safeStart >= pts.length - 1) {
        return pts.length - 1;
      }

      var chainQuad = _Quadrant.default.quadrant(pts[safeStart], pts[safeStart + 1]);

      var last = start + 1;

      while (last < pts.length) {
        if (!pts[last - 1].equals2D(pts[last])) {
          var quad = _Quadrant.default.quadrant(pts[last - 1], pts[last]);

          if (quad !== chainQuad) break;
        }

        last++;
      }

      return last - 1;
    }
  }, {
    key: "getChains",
    value: function getChains() {
      if (arguments.length === 1) {
        var pts = arguments[0];
        return MonotoneChainBuilder.getChains(pts, null);
      } else if (arguments.length === 2) {
        var _pts = arguments[0],
            context = arguments[1];
        var mcList = new _ArrayList.default();
        var startIndex = MonotoneChainBuilder.getChainStartIndices(_pts);

        for (var i = 0; i < startIndex.length - 1; i++) {
          var mc = new _MonotoneChain.default(_pts, startIndex[i], startIndex[i + 1], context);
          mcList.add(mc);
        }

        return mcList;
      }
    }
  }, {
    key: "toIntArray",
    value: function toIntArray(list) {
      var array = new Array(list.size()).fill(null);

      for (var i = 0; i < array.length; i++) {
        array[i] = list.get(i).intValue();
      }

      return array;
    }
  }]);

  return MonotoneChainBuilder;
}();

exports.default = MonotoneChainBuilder;

MonotoneChainBuilder.constructor_ = function () {};